import { render } from "./LoanSDABalai.vue?vue&type=template&id=1808203a"
import script from "./LoanSDABalai.vue?vue&type=script&lang=js"
export * from "./LoanSDABalai.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__